import fetch from '@src/common/lib/axios'
export const api = {
  assetsManage: {
    exportFireAssetDeviceQrcode:"bms/assetdeviceinspection/exportFireAssetDeviceQrcode.json",
    queryAssetsList: 'bms/assetdeviceinspection/queryPatrolItemGroupConfigInfoByPage.json',
    updatePatrolItemGroupConfigInfo: 'bms/assetdeviceinspection/updatePatrolItemGroupConfigInfo.json',
    deleteItemConfig: 'bms/assetdeviceinspection/deletePatrolItemGroupConfigInfo.json',
    addItemConfig: 'bms/assetdeviceinspection/addPatrolItemGroupConfigInfo.json',
    queryPlan: 'bms/assetdeviceinspection/queryPatrolPlanInfoByPage.json',
    addPlanInfo: 'bms/assetdeviceinspection/addPatrolPlanInfo.json',
    deletePlan: 'bms/assetdeviceinspection/deletePatrolPlanInfo.json',
    queryPlanDetail: 'bms/assetdeviceinspection/queryPatrolPlanDetail.json',
    updatePlanInfo: 'bms/assetdeviceinspection/updatePatrolPlanInfo.json',
    addFireAssetDeviceInfo: 'bms/assetdeviceinspection/addFireAssetDeviceInfo.json',
    updateFireAssetDeviceInfo: 'bms/assetdeviceinspection/updateFireAssetDeviceInfo.json',
    queryFireAssetDeviceByPage: 'bms/assetdeviceinspection/queryFireAssetDeviceByPage.json',
    queryFireAssetDeviceDetail: 'bms/assetdeviceinspection/queryFireAssetDeviceDetail.json',
    deleteFireAssetDeviceInfo: 'bms/assetdeviceinspection/deleteFireAssetDeviceInfo.json',
    queryBuildingList: 'cms/building/queryBuildingListApi.json', //查询楼栋楼层list
    queryPatrolPlanList: 'bms/assetdeviceinspection/queryPatrolPlanList.json',
    queryPatrolItemGroupConfigList: 'bms/assetdeviceinspection/queryPatrolItemGroupConfigList.json',
    queryPersonnel: '/vas/personnel/queryPersonListApi.json',
    queryFireAssetDeviceRecordByPage: 'bms/assetdeviceinspection/queryFireAssetDeviceRecordByPage.json',
    queryFireAssetAnalysisByPage: 'bms/assetdeviceinspection/queryFireAssetAnalysisByPage.json',
    exportFireAssetDeviceRecord: 'bms/assetdeviceinspection/exportFireAssetDeviceRecord.json',
    exportFireAssetDevice: 'bms/assetdeviceinspection/exportFireAssetDevice.json',
    importFireAssetDevice: 'bms/assetdeviceinspection/importFireAssetDevice.json',
    exportFireAssetDevicePicture:"bms/assetdeviceinspection/exportFireAssetDevicePicture.json",
  }
}
